import { render, staticRenderFns } from "./VipMemberDetail.vue?vue&type=template&id=72e24d1b&scoped=true&"
import script from "./VipMemberDetail.vue?vue&type=script&lang=js&"
export * from "./VipMemberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e24d1b",
  null
  
)

export default component.exports